import { EDIT_MENU, GET_ALL_MENU } from '@/api/menu/menu';

const state = {
    menu: [],
};

const mutations = {
    setMenu: (state, payload) => {
        state.menu = payload;
    },
};

const actions = {
    getMenu: async ({ commit }, params) => {
        try {
            const resp = await GET_ALL_MENU(params);
            if (resp.data.httpCode === 200) {
                commit('setMenu', resp.data.data); 
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp && resp.data && resp.data.httpCode === 404) {
                commit('setMenu', []);
            }
            throw err;
        }
    },
    updateMenu: async ({ }, args) => {
        return await EDIT_MENU(args);
    },
};

const getters = {
    menu: (state) => state.menu,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
